const SEEN_KEY = 'wapharma-admin-catalog-import-seen-results';
const LEGACY_SEEN_SESSION_KEY = 'wapharma-admin-catalog-import-seen-results';
const NOTIFIED_KEY = 'wapharma-admin-catalog-import-notified';
const MAX_IDS = 50;

function readIdSet(storageKey: string): Set<string> {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as string[];
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function writeIdSet(storageKey: string, set: Set<string>) {
  try {
    const trimmed = [...set].slice(-MAX_IDS);
    localStorage.setItem(storageKey, JSON.stringify(trimmed));
  } catch {
    /* ignore */
  }
}

function migrateLegacySessionSeen() {
  try {
    const raw = sessionStorage.getItem(LEGACY_SEEN_SESSION_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as string[];
    if (Array.isArray(parsed)) {
      const merged = readIdSet(SEEN_KEY);
      for (const id of parsed) merged.add(id);
      writeIdSet(SEEN_KEY, merged);
    }
    sessionStorage.removeItem(LEGACY_SEEN_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Jobs the user acknowledged (inbox seen / dismiss / close result). */
export function readSeenCatalogImportJobIds(): Set<string> {
  migrateLegacySessionSeen();
  return readIdSet(SEEN_KEY);
}

export function markCatalogImportJobSeen(jobId: string) {
  if (!jobId) return;
  const set = readSeenCatalogImportJobIds();
  set.add(jobId);
  writeIdSet(SEEN_KEY, set);
}

/** Jobs we already surfaced via toast / desktop notification (survives reload). */
export function readNotifiedCatalogImportJobIds(): Set<string> {
  return readIdSet(NOTIFIED_KEY);
}

export function markCatalogImportJobNotified(jobId: string) {
  if (!jobId) return;
  const set = readNotifiedCatalogImportJobIds();
  set.add(jobId);
  writeIdSet(NOTIFIED_KEY, set);
}

export const CATALOG_IMPORT_SEEN_EVENT = 'wapharma-catalog-import-seen';

export function dispatchCatalogImportSeen(jobId: string) {
  if (!jobId) return;
  markCatalogImportJobSeen(jobId);
  window.dispatchEvent(new CustomEvent(CATALOG_IMPORT_SEEN_EVENT, { detail: { jobId } }));
}
